import React from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./StoryMatchPickFeedback.css";

export type StoryMatchPickFeedbackVariant = "correct" | "wrong";

type Props = {
  variant: StoryMatchPickFeedbackVariant;
};

/**
 * Full-frame dimmer over a match thumbnail plus a light solid correct/wrong badge and a neutral (white) icon.
 */
const StoryMatchPickFeedback = (props: Props) => {
  const { variant } = props;
  return (
    <div className="StoryMatchPickFeedback" aria-hidden="true">
      <span
        className={clsx(
          "StoryMatchPickFeedback__badge",
          `StoryMatchPickFeedback__badge--${variant}`,
        )}
      >
        <FontAwesomeIcon
          icon={variant === "correct" ? faCheck : faXmark}
          className="StoryMatchPickFeedback__icon"
        />
      </span>
    </div>
  );
};

export default StoryMatchPickFeedback;
